// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-indicator .item-row{display:flex;align-items:center;height:14px;margin-top:8px}.active-indicator .text{margin-left:5px}`, "",{"version":3,"sources":["webpack://./src/components/portal/controls/activeIndicator/style.scss"],"names":[],"mappings":"AAEI,4BACI,YAAA,CACA,kBAAA,CACA,WAAA,CACA,cAAA,CAGJ,wBACI,eAAA","sourcesContent":[".active-indicator {\n\n    .item-row {\n        display: flex;\n        align-items: center;\n        height: 14px;\n        margin-top: 8px;\n    }\n    \n    .text {\n        margin-left: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeIndicator": `active-indicator`,
	"itemRow": `item-row`,
	"text": `text`
};
export default ___CSS_LOADER_EXPORT___;
